var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidecart js-sidecart",
      attrs: { "data-sidecart": "" },
      on: { carttoggle: _vm.cartDisplay }
    },
    [
      _vm.sidecartOpen
        ? _c("div", {
            staticClass: "sidecart__overlay",
            on: { click: _vm.cartDisplay }
          })
        : _vm._e(),
      _c("transition", { attrs: { name: "slide" } }, [
        _vm.sidecartOpen
          ? _c(
              "div",
              {
                staticClass: "sidecart__drawer",
                attrs: { "data-sidecart-visible": "" }
              },
              [
                _c("div", { staticClass: "sidecart__header" }, [
                  _c("div", { staticClass: "sidecart__header-content" }, [
                    _c("h2", { staticClass: "sidecart__title" }, [
                      _vm._v(_vm._s(_vm.heading)),
                      _c("small", [_vm._v(" " + _vm._s(_vm.cartCountText))])
                    ]),
                    _c(
                      "button",
                      {
                        staticClass: "button--icon sidecart__close",
                        on: {
                          click: function($event) {
                            return _vm.$store.dispatch("cart/closeSidecart")
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "u-sr-only" }, [
                          _vm._v("Close side cart")
                        ]),
                        _c("Icon", {
                          attrs: { name: "close", height: "30", width: "30" }
                        })
                      ],
                      1
                    ),
                    this.sampleProducts.showSampleProducts &&
                    _vm.sampleProducts.showThresholdBar
                      ? _c(
                          "div",
                          { staticClass: "sidecart__progressbar-wrapper" },
                          [
                            _c("p", {
                              staticClass: "sidecart__progressbar-heading",
                              domProps: {
                                innerHTML: _vm._s(_vm.progressBarText)
                              }
                            }),
                            _c(
                              "div",
                              { staticClass: "sidecart__progressbar" },
                              [
                                _c("span", {
                                  style: "width:" + _vm.progressBarWidth + "%;"
                                })
                              ]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]),
                _c("div", { staticClass: "sidecart__container" }, [
                  _vm.cartData.item_count > 0
                    ? _c("div", { staticClass: "sidecart__contents-wrapper" }, [
                        _c(
                          "div",
                          { staticClass: "sidecart__contents" },
                          [
                            _vm._l(_vm.cartData.items, function(item, index) {
                              return _c("CartLineItem", {
                                key: _vm.reload + index,
                                attrs: {
                                  item: item,
                                  line: index + 1,
                                  reload: _vm.upsellProductAdded,
                                  freeSampleProduct: _vm.isFreeSampleProduct(
                                    item.variant_id
                                  )
                                },
                                on: { updateCart: _vm.updateCart }
                              })
                            }),
                            this.sampleProducts.showSampleProducts &&
                            this.sampleProducts.products.length > 0
                              ? _c(
                                  "ul",
                                  {
                                    staticClass: "sidecart__sample-product-list"
                                  },
                                  [
                                    this.sampleProducts.heading
                                      ? _c("h6", {
                                          staticClass:
                                            "sidecart__sample-product-heading",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.sampleProductsHeading
                                            )
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._l(
                                      this.sampleProducts.products,
                                      function(product, index) {
                                        return _c(
                                          "li",
                                          {
                                            key: index,
                                            staticClass:
                                              "sidecart__sample-products-item",
                                            class: {
                                              disabled: !_vm.hasThresholdMet
                                            }
                                          },
                                          [
                                            _c("img", {
                                              staticClass:
                                                "sidecart__sample-product-image",
                                              attrs: {
                                                src: _vm._f("image")(
                                                  product.images[0].sizes.xs,
                                                  "200x"
                                                ),
                                                alt: product.title
                                              }
                                            }),
                                            _c("p", {
                                              staticClass:
                                                "sidecart__sample-product-title",
                                              domProps: {
                                                textContent: _vm._s(
                                                  product.title
                                                )
                                              }
                                            }),
                                            _vm.hasThresholdMet
                                              ? _c("a", {
                                                  staticClass:
                                                    "sidecart__sample-product-cta",
                                                  class: {
                                                    disabled:
                                                      !_vm.addToCartAllowed &&
                                                      !_vm.isSampleProductInCart(
                                                        product.variants[0].id
                                                      ),
                                                    active: _vm.isSampleProductInCart(
                                                      product.variants[0].id
                                                    )
                                                  },
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.isSampleProductInCart(
                                                        product.variants[0].id
                                                      )
                                                        ? "added!"
                                                        : "add"
                                                    )
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.preventDefault()
                                                      return _vm.addRemoveSampleProduct(
                                                        product.variants[0].id
                                                      )
                                                    }
                                                  }
                                                })
                                              : _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "sidecart__sample-product-cta disabled"
                                                  },
                                                  [_vm._v("add")]
                                                )
                                          ]
                                        )
                                      }
                                    )
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _c("div", { staticClass: "upsell-wrapper" }, [
                              _c("h6", {
                                staticClass: "upsell-wrapper__header-text",
                                domProps: {
                                  textContent: _vm._s(_vm.upsellText)
                                }
                              })
                            ])
                          ],
                          2
                        ),
                        _c("div", { staticClass: "sidecart__footer" }, [
                          _c("h5", { staticClass: "sidecart__subtotal" }, [
                            _c("span", [_vm._v("Subtotal:")]),
                            _c("span", { staticClass: "subtotal__amount" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("moneyWithoutDecimals")(
                                    _vm.getCartTotal
                                  )
                                )
                              )
                            ])
                          ]),
                          _c("div", { staticClass: "sidecart__ctas" }, [
                            _c(
                              "a",
                              {
                                staticClass: "button button--secondary",
                                attrs: { href: "/cart" }
                              },
                              [_vm._v("view cart")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "button button--primary",
                                on: { click: _vm.checkoutRedirect }
                              },
                              [_vm._v("Checkout")]
                            )
                          ])
                        ])
                      ])
                    : _c(
                        "div",
                        { key: "empty", staticClass: "sidecart__empty" },
                        [
                          _c("p", { staticClass: "sidecart__empty-text" }, [
                            _vm._v(_vm._s(_vm.emptyText))
                          ])
                        ]
                      )
                ])
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }